"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Badge = exports.BadgeStatus = void 0;
const classnames_1 = __importDefault(require("classnames"));
const React = __importStar(require("react"));
var BadgeStatus;
(function (BadgeStatus) {
    BadgeStatus["SUCCESS"] = "green";
    BadgeStatus["INFO"] = "blue";
    BadgeStatus["WARNING"] = "yellow";
    BadgeStatus["ERROR"] = "red";
})(BadgeStatus = exports.BadgeStatus || (exports.BadgeStatus = {}));
const Badge = ({ children, status, className }) => {
    const classNames = classnames_1.default('badge', `badge-${status}`, {
        [className || '']: !!className,
    });
    return (React.createElement("span", { className: classNames }, children));
};
exports.Badge = Badge;
//# sourceMappingURL=Badge.js.map